/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Socket from 'fierry/rpc/socket';
import Commands from 'fierry/rpc.old/commands';

import * as Translation from 'fierry/rpc/translate';

import Protocol from 'fierry/rpc/protocol';


export default class Client
{
  constructor ({ Application, routes, location })
  {
    this.application = Application.create();

    this.routes = routes;
    this.location = location;

    this.open = false;

    this.listeners = new Set();

    this.protocol = new Protocol(this);
    this.translation = new Translation.Standard();

    this.socket = new Socket(this);
    this.commands = new Commands(this);
  }


  getLocation ()
  {
    return this.location;
  }


  connect ()
  {
    this.socket.onOpen.connect(this.onSocketOpen);
    this.socket.onClose.connect(this.onSocketClose);

    this.socket.connect((message) => this.socket.executeMessage(message));
  }


  disconnect ()
  {
    this.socket.disconnect();
  }


  send (routing, command, json)
  {
    return this.commands.schedule([ routing ], command, json);
  }


  subscribe (listener)
  {
    this.listeners.add(listener);

    return () => this.listeners.delete(listener);
  }


  getSnapshot ()
  {
    return this.application.getState();
  }


  notifyChanged ()
  {
    for (const listener of this.listeners)
    {
      listener();
    }
  }

  onSocketOpen = () =>
  {
    this.open = true;

    this.notifyChanged();
  }


  onSocketClose = () =>
  {
    if (this.open)
    {
      window.location.reload();
    }
  }


};
